export default function () {
    const contactElement = document.querySelector('#contact');
    const contactCloseElement = document.querySelector('#contact-close');
    if (!contactElement || !contactCloseElement) {
        return;
    }

    window.addEventListener('contactOpen', function (event) {
        contactElement.classList.add('active');
        toggleDocumentOverflow(true);
    });

    contactCloseElement.addEventListener('click', e => {
        contactElement.classList.remove('active');
        toggleDocumentOverflow(false);
    })
}

function toggleDocumentOverflow (state) {
    document.documentElement.classList.toggle('nooverflow', state);
}
